/**
 * Created by Arif Topcu in 2019
 */

import analyticsReducer from "./analytics/reducer";
import bookAnalyticsReducer from "./bookAnalytics/reducer";
import bookAnalyticsScope from "./bookAnalytics/scope";
import analyticsScope from "./analytics/scope";
import AppReducer from "./app/reducer";
import attributesReducer from "./attributes/reducer";
import attributesScope from "./attributes/scope";
import betasReducer from "./betas/reducer";
import betasScope from "./betas/scope";
import cfReducer from "./cf/reducer";
import cfScope from "./cf/scope";
import dttReducer from "./durationToTarget/reducer";
import dttScope from "./durationToTarget/scope";
import factribReducer from "./factrib/reducer";
import factribScope from "./factrib/scope";
import grid from "./grid/reducer";
import issueCountReducer from "./issueCount/reducer";
import issueCountScope from "./issueCount/scope";
import issuerCountReducer from "./issuerCount/reducer";
import issuerCountScope from "./issuerCount/scope";
import lastBuySellReducer from "./lastBuySell/reducer";
import lastBuySellScope from "./lastBuySell/scope";

import clientLossRstrReducer from "./clientLossRstr/reducer";
import clientLossRstrScope from "./clientLossRstr/scope";

import realizedGLReducer from "./realizedGL/reducer";
import realizedGLScope from "./realizedGL/scope";

import miscReducer from "./misc/reducer";
import miscScope from "./misc/scope";
import perfReturnsReducer from "./perfReturns/reducer";
import perfReturnsScope from "./perfReturns/scope";
import pivotsReducer from "./pivots/reducer";
import pivotsScope from "./pivots/scope";
import ratingsReducer from "./ratings/reducer";
import ratingsScope from "./ratings/scope";
import scenario from "./scenario/reducer";
import SelectionsReducer from "./selections/reducer";
import teReducer from "./te/reducer";
import teScope from "./te/scope";
import tteReducer from "./tte/reducer";
import tteScope from "./tte/scope";
import scenarioAnalysisReducer from "./scenarioAnalysis/reducer";
import scenarioAnalysisScope from "./scenarioAnalysis/scope";

import scan2Reducer from "./scan2/reducer";
import scan2Scope from "./scan2/scope";
import { combineReducers } from "redux";

export default combineReducers({
  App: AppReducer,
  Selections: SelectionsReducer,
  [analyticsScope]: analyticsReducer,
  [bookAnalyticsScope]: bookAnalyticsReducer,
  [attributesScope]: attributesReducer,
  [betasScope]: betasReducer,
  [cfScope]: cfReducer,
  [dttScope]: dttReducer,
  [factribScope]: factribReducer,
  [issueCountScope]: issueCountReducer,
  [issuerCountScope]: issuerCountReducer,
  [lastBuySellScope]: lastBuySellReducer,
  [realizedGLScope]: realizedGLReducer,
  [miscScope]: miscReducer,
  [perfReturnsScope]: perfReturnsReducer,
  [pivotsScope]: pivotsReducer,
  [ratingsScope]: ratingsReducer,
  [teScope]: teReducer,
  [tteScope]: tteReducer,
  [scenarioAnalysisScope]: scenarioAnalysisReducer,
  [scan2Scope]: scan2Reducer,
  [clientLossRstrScope]: clientLossRstrReducer,
  grid,
  scenario,
});
